const State = {
  notePhraseList: [],
  maxSortNumber: 0
}

export default State
